export const update = (state, data) => {
  for (let key in state) {
    if (key in data) {
      state[key] = data[key];
    }
  }
};
